export default __webpack_public_path__ + "static/media/reward-icon.7966ae2c.svg";